module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjcAAABGBAMAAADC56jQAAAAGFBMVEUAAADiJB3jIxzhJRriJBvgJBrhJBrhJBrFgFZxAAAAB3RSTlMAIyRutrf2BW15wAAAANZJREFUeNrt1sERQUEQRdFhI12hCkEIthZ8Cej3aV1W54VwaqrvrGXlDqczhGL3I4N6cODAgfPHXeHUu8Dxcjrb3Jx6DzhwpHz8HsMJJYfj5fRKDifECg4cKR+PFZwQKzhweiWHE2IFB46Uj5ccTogVHDi9ksMJsYIDR8rHSw4nxAoOnF7J4YRYwYEj5ZO7wdn55sCB4+aMxwrO2z3hwPmh5HBCrODAkfLxksMJsYIDp1dyOCFWcOBI+XjJ4YRYwYHTKzmcECs4cKR8vORw4Hy1Dc4HJV8vTys0u3Eoq4YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/juxing-red.png
// module id = DoLC
// module chunks = 70